<div
  class="card card-custom"
  [ngClass]="{ 'card-body-progress card-body-progress-overlay': viewLoading }"
>
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label" translate>{{ 'MEETING.INPUT.INFO' | translate }}</h3>
    </div>
  </div>
  <div class="card-body">
    <div class="card-body-progress">
      <mat-spinner [diameter]="20"></mat-spinner>
    </div>
    <dl class="row">
      <div class="col-sm-12">
        <div class="row">
          <dt class="col-sm-4 py-2">{{ 'MEETING.INPUT.TIME' | translate }}</dt>
          <dd class="col-sm-8 py-2">{{ getDate(meeting.from_time) | date : 'MM-dd-yy h:mm a' }}</dd>

          <dt class="col-sm-4 py-2">{{ 'MEETING.INPUT.SUBJECT' | translate }}</dt>
          <dd class="col-sm-8 py-2">{{ meeting.subject }}</dd>

          <dt class="col-sm-4 py-2">{{ 'MEETING.INPUT.LOCATION' | translate }}</dt>
          <dd class="col-sm-8 py-2">{{ meeting.location }}</dd>

          <dt class="col-sm-4 py-2">{{ 'MEETING.INPUT.DURATION' | translate }}</dt>
          <dd class="col-sm-8 py-2">{{ estimateDuration(meeting.duration) }}</dd>

          <dt class="col-sm-4 py-2">{{ 'MEETING.INPUT.WITH' | translate }}</dt>
          <dd class="col-sm-8 py-2">{{ getReceivers(1).join(', ') }}</dd>

          <dt class="col-sm-4 py-2">{{ 'MEETING.INPUT.DESCRIPTION' | translate }}</dt>
          <dd class="col-sm-8 py-2">{{ meeting.body }}</dd>

          <dt class="col-sm-4 py-2">{{ 'MEETING.INPUT.RESPONSIBLE' | translate }}</dt>
          <dd class="col-sm-8 py-2">{{ getReceivers(2) }}</dd>
        </div>

        <div class="row" *ngIf="loadingTags || (!loadingTags && meetingTags.length)">
          <dt class="col-sm-4 py-2">{{ 'MESSAGE.INPUT.TAG' | translate }}</dt>
          <dd class="col-sm-8 py-2">
            <div *ngIf="loadingTags">
              <mat-spinner [diameter]="20"></mat-spinner>
            </div>
            <div *ngIf="!loadingTags">
              <kt-tags [readOnly]="true" [readOnlyValue]="meetingTags"></kt-tags>
            </div>
          </dd>
        </div>

        <div class="row">
          <dt class="col-sm-12 py-2">{{ 'MEETING.INPUT.FILES' | translate }}</dt>
          <dd class="col-sm-12 py-2">
            <kt-attachments-list [data]="attachmentData"></kt-attachments-list>
          </dd>
        </div>
      </div>
    </dl>
  </div>
  <div class="card-footer">
    <div class="d-flex justify-content-between">
      <div class="mr-2"></div>
      <div>
        <button mat-button mat-dialog-close>{{ 'TABLE.CLOSE' | translate }}</button>
      </div>
    </div>
  </div>
</div>
